import { createContext } from 'react';
import { ToastNotificationsContextType } from './types';

export const ToastNotificationsContext = createContext<ToastNotificationsContextType>(
  {} as ToastNotificationsContextType,
);
